/**
 * 公司/法人实体 常量
 */
export const COMPANY_ID = {
    WITTY: '1000',
    PSP: '2000',
    YPC: '3000',
};
export const DEFAULT_COMPANY_ID = COMPANY_ID.WITTY;
/**
 * 当 controller 收到的请求未带 x-company-id header / body.companyId 时,
 * 工厂上下文的兜底值。历史上是 PSP（越南厂,业务量最大,默认导向工厂视图）。
 * 与 DEFAULT_COMPANY_ID(=WITTY 总部)语义不同 —— 那个是认证上下文的默认。
 *
 * @deprecated 新代码必须从 `companyContext.getStore()?.companyId` 取（main.ts
 * 的 middleware 已为每个请求注入 AsyncLocalStorage 上下文）。本常量仅作为
 * legacy 路径的纵深防御兜底；新增引用会被 ESLint `no-restricted-imports`
 * 阻断。要兜底缺失上下文，请显式抛 BadRequestException 而非默认 PSP。
 */
export const FALLBACK_FACTORY_COMPANY_ID = COMPANY_ID.PSP;
export const COMPANY_CODE = {
    WITTY: 'WITTY',
    PSP: 'PSP',
    YPC: 'YPC',
};
export const COMPANIES = [
    {
        id: COMPANY_ID.WITTY,
        code: COMPANY_CODE.WITTY,
        name: 'WITTY IDEA CO.,LTD',
        region: 'BVI HQ',
        flag: '\u{1F1FB}\u{1F1EC}',
        bgImage: '/assets/witty_bg.png',
        accentColor: 'text-blue-400',
        btnColor: 'bg-blue-600 hover:bg-blue-500',
    },
    {
        id: COMPANY_ID.PSP,
        code: COMPANY_CODE.PSP,
        name: 'PEAK SPEED PRINTING',
        region: 'Vietnam Factory',
        flag: '\u{1F1FB}\u{1F1F3}',
        bgImage: '/assets/psp_bg.png',
        accentColor: 'text-red-400',
        btnColor: 'bg-red-700 hover:bg-red-600',
    },
    {
        id: COMPANY_ID.YPC,
        code: COMPANY_CODE.YPC,
        name: 'YANLORD PRINTING',
        region: 'Cambodia Factory',
        flag: '\u{1F1F0}\u{1F1ED}',
        bgImage: '/assets/ypc_bg.png',
        accentColor: 'text-purple-400',
        btnColor: 'bg-purple-700 hover:bg-purple-600',
    },
];
/** 公司ID → 默认语言 映射 */
export const COMPANY_DEFAULT_LOCALE = {
    [COMPANY_ID.WITTY]: 'zh',
    [COMPANY_ID.PSP]: 'vi',
    [COMPANY_ID.YPC]: 'zh',
};
/** 公司ID → i18n 名称键 映射 */
export const COMPANY_I18N_KEY = {
    [COMPANY_ID.WITTY]: 'home.companyWitty',
    [COMPANY_ID.PSP]: 'home.companyPsp',
    [COMPANY_ID.YPC]: 'home.companyYpc',
};
/** 公司ID → 默认本位币 映射（凭证/发票/PO/SO 等表单的 currency 默认值） */
export const COMPANY_DEFAULT_CURRENCY = {
    [COMPANY_ID.WITTY]: 'USD',
    [COMPANY_ID.PSP]: 'VND',
    [COMPANY_ID.YPC]: 'USD',
};
/** 兜底币种（未登录或 companyId 不在映射中时使用） */
export const FALLBACK_CURRENCY = 'USD';
/** 根据 companyId 取默认币种，缺省兜底 USD */
export function getDefaultCurrencyForCompany(companyId) {
    if (!companyId)
        return FALLBACK_CURRENCY;
    return COMPANY_DEFAULT_CURRENCY[companyId] ?? FALLBACK_CURRENCY;
}
